import type {
  BundleComponentDto,
  ComponentDto,
  OnsiteUpsellComponentDto,
} from "@intelligems/ig-types/dtos/components";

/**
 * The component types the onsite upsell renderer serves. Lives here rather than
 * in ig-types for the same reason as `component-placement`: the storefront
 * plugin runs this and may only import TYPES from ig-types.
 */
export function isOnsiteUpsellComponent(
  component: ComponentDto
): component is OnsiteUpsellComponentDto | BundleComponentDto {
  return (
    component.config.type === "onsiteUpsell" ||
    component.config.type === "bundleOnsiteUpsell"
  );
}
